import { themes } from '@weenat/theme'

const theme = themes.light

export default theme
